import { faTrashCan as farTrashCan } from "@awesome.me/kit-3777c2145e/icons/classic/regular";
import { faPenToSquare as fasPenToSquare } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { formatText } from "@ui/format";
import type { ReactNode } from "react";
import React from "react";
import { Col, ListGroup, Row } from "react-bootstrap";
import { Button } from "../../Button";
import type { FormLoanSimpleData } from "./FormLoanSimpleItem.data";

interface Props extends FormLoanSimpleData {
	size?: "sm";
	disabled: boolean;
	onDelete(): void;
	onEdit(): void;
}

export class FormLoanSimpleItem extends React.PureComponent<Props> {
	public render(): ReactNode {
		const { loanTypeName, debt, size, disabled, onEdit, onDelete } = this.props;

		return (
			<ListGroup.Item className="flex-column align-items-start px-3">
				<Row>
					<Col className={size === "sm" ? "px-2" : "mb-sm-0 mb-2"} xs={size === "sm" ? 8 : 6}>
						<div className="h6 text-muted text-truncate mb-1">{loanTypeName}</div>
						<div className="h3">{formatText(debt, "ft")}</div>
					</Col>
					<Col className={size === "sm" ? "px-2 text-right" : "text-right"} xs={size === "sm" ? 4 : 6}>
						<Button
							className={size === "sm" ? "ml-2" : "ml-2 mb-2"}
							icon={<FontAwesomeIcon icon={fasPenToSquare} />}
							variant="info"
							size="sm"
							outlined
							disabled={disabled}
							onClick={onEdit}
							children={size === "sm" ? undefined : "Módosítás"}
						/>
						<Button
							className={size === "sm" ? "ml-2" : "ml-2 mb-2"}
							icon={<FontAwesomeIcon icon={farTrashCan} />}
							variant="danger"
							size="sm"
							outlined
							disabled={disabled}
							onClick={onDelete}
							children={size === "sm" ? undefined : "Törlés"}
						/>
					</Col>
				</Row>
			</ListGroup.Item>
		);
	}
}
